import { useRef } from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { Field } from 'formik';
import React
    from "react";
let useStyles = makeStyles(() => ({
    root: {
        minWidth: 296,
        maxWidth: '100%',
        position: 'relative',
        '@media (max-width: 500px)': {
            minWidth: '99%',
            marginRight: 'auto',
            marginLeft: 'auto',
        },

    },
    label: {
        marginBottom: 12,
        fontSize: 14,
        fontWeight: 400,
    },
    TextField: {
        '& .MuiInputBase-input': {
            textAlign: 'center',
            height: 15,
        }
    },
    errorTextfield: {
        color: '#E60001',
    },
    textError: {
        color: '#E60001',
        fontSize: 12,
        fontWeight: 400,
        position: 'absolute',
    }
}))


export default function Index({ label, placeholder, dataForm, ...inputProps }) {

    let classes = useStyles();
    let myRef = useRef(null);


    const handleClick = () => {
        myRef.current.focus();
    };

    return (
        <div className={classes['root']} onClick={() => handleClick()}>

            <Field name={dataForm?.id}>
                {({ field }) => {

                    return (
                        <TextField
                        label={label}
                            inputRef={myRef}
                            {...field}
                            variant="outlined"
                            size="small"
                            fullWidth
                            className={classes['TextField']}
                            error={dataForm?.errors?.[dataForm?.id] && dataForm?.touched?.[dataForm?.id]}
                            helperText={
                                dataForm?.errors?.[dataForm?.id] && dataForm?.touched?.[dataForm?.id] ? (
                                    <span className={classes['textError']} style={{ color: 'red' }}>{dataForm?.errors?.[dataForm?.id]}</span>
                                ) : null
                            }
                            InputProps={{
                                ...inputProps,
                                className: dataForm?.errors?.[dataForm?.id] && dataForm?.touched?.[dataForm?.id] ? classes['errorTextfield'] : '',
                                style: { borderColor: dataForm?.errors?.[dataForm?.id] && dataForm?.touched?.[dataForm?.id] ? 'red' : 'rgb(179, 179, 179)', height: 42 },
                            }}
                            placeholder={placeholder?placeholder:null}
                        />
                    )
                }}
            </Field>
        </div>
    )
}
